import { call, all, put, takeEvery } from 'redux-saga/effects';

import URLs from '../../../constants/urls';
import { apiPython as api } from '../../../service/api';
import { GET_TECHNICAL_ASSESSMENTS } from '../../actions/TechnicalAssessments/actionTypes';
import {
  getAssessmentDetailsAction,
  getTechnicalAssessmentsAction,
  saveAssessmentAction,
  setOpenTechnicalModal,
  setTechnicalAssessmentDetails,
  setTechnicalAssessmentErrorMessage,
  setTechnicalAssessmentSuccessMessage,
  setTechnicalAssessments,
  setTechnicalAssessmentsLoader
} from '../../features/technicalAssessments/technicalAssessmentsSlice';

export function* getTechnicalAssessmentsSaga() {
  try {
    const response = yield api.get(URLs.GET_TECHNICAL_ASSESSMENTS);
    yield put(setTechnicalAssessments(response.data.data));
    yield put(setTechnicalAssessmentsLoader(false));
  } catch (error) {
    yield put(setTechnicalAssessmentErrorMessage('Something went wrong'));
  }
}

export function* saveTechnicalAssessmentSaga(action) {
  yield put(setTechnicalAssessmentsLoader(true));

  try {
    const response = yield api.post(URLs.SAVE_TECHNICAL_ASSESSMENT, action.payload);
    yield put(setTechnicalAssessmentsLoader(false));
    if (response.data.status === 'Success') {
      yield put(setTechnicalAssessmentSuccessMessage('Saved Successfully'));
      yield put(setOpenTechnicalModal({ open: false, action: null }));
      yield put(getTechnicalAssessmentsAction());
    }
  } catch (error) {
    yield put(setTechnicalAssessmentsLoader(false));
    yield put(setTechnicalAssessmentErrorMessage('Something went wrong'));
  }
}

export function* getTechnicalAssessmentDetailsSaga(action) {
  yield put(setTechnicalAssessmentsLoader(true));

  try {
    const response = yield api.get(`${URLs.GET_TECHNICAL_ASSESSMENT_DETAILS}?id=${action.payload}`);
    yield put(setTechnicalAssessmentsLoader(false));
    yield put(setTechnicalAssessmentDetails(response.data.data));
  } catch (error) {
    yield put(setTechnicalAssessmentsLoader(false));
    yield put(setTechnicalAssessmentErrorMessage('Something went wrong'));
  }
}

export function* watchTechnicalAssessments() {
  yield takeEvery(GET_TECHNICAL_ASSESSMENTS, getTechnicalAssessmentsSaga);
  yield takeEvery(saveAssessmentAction.type, saveTechnicalAssessmentSaga);
  yield takeEvery(getAssessmentDetailsAction.type, getTechnicalAssessmentDetailsSaga);
}

export default function* technicalAssessmentsSaga() {
  yield all([watchTechnicalAssessments()]);
}
